const SPREADSHEET_NAME_DEFAULT: string = 'Sheet1';

export default SPREADSHEET_NAME_DEFAULT;
